export class VenturiWidget {
  constructor(root) {
    this.root = root;
    this.rvent = this.q('[data-vt-input]');
    this.rvent.addEventListener('input', () => this.update());
    this.update(); // Initialzustand
  }
  q(sel) { return this.root.querySelector(sel); }
  update(){
    const pct = parseFloat(this.rvent.value);   // 5..100
    const a = pct/100;                     // Öffnungsanteil
    this.q('[data-vt-pct]').textContent = pct.toFixed(0);

    // Q real ∝ Öffnungsfläche (bei natürlicher Lüftung mit fester Druckdifferenz)
    const q = a;
    this.q('[data-vt-qfill]').style.width = (q*100).toFixed(0) + '%';
    this.q('[data-vt-qval]').textContent  = (q*100).toFixed(0) + ' %';

    // v laut Venturi-Annahme (Kontinuität, festes Q) ∝ 1/A — normiert auf a_min=0.05
    const vA = Math.min(0.05/a, 1);
    this.q('[data-vt-vfill]').style.width = (vA*100).toFixed(0) + '%';
    this.q('[data-vt-vval]').textContent  = vA >= 0.999 ? 'max' : (vA*100).toFixed(0) + ' %';

    // Türblatt schwenkt (0..90°) je Öffnung
    const theta = a * 90 * Math.PI/180;
    const px=60, py=85, L=85;
    this.q('[data-vt-door]').setAttribute('x2', (px + L*Math.cos(theta)).toFixed(1));
    this.q('[data-vt-door]').setAttribute('y2', (py + L*Math.sin(theta)).toFixed(1));

    // Strom-Dicke ∝ Q
    this.q('[data-vt-flow]').setAttribute('stroke-width', (1.5 + q*11).toFixed(1));

    // Fazit
    let f;
    if(a <= 0.30)
      f = 'Schmaler Spalt: Die Venturi-Annahme (amber) wirkt groß — es „zieht" spürbar. Aber der Luftwechsel Q (teal) ist klein: es wird kaum Luft getauscht.';
    else if(a >= 0.80)
      f = 'Tür weit offen: Q ist maximal — genau das zählt fürs Lüften. Die „gefühlte" Spaltgeschwindigkeit verliert an Bedeutung.';
    else
      f = 'Halb offen: Q wächst mit der Öffnung. Für maximalen Austausch weiter aufmachen statt anlehnen.';
    this.q('[data-vt-fazit]').textContent = f;
  }
}
